import { Stack, Typography } from '@mui/material';
import { _ } from '/@/locale';
import { HelpCategoryGroups, type HelpCenterCategoryGroup } from './help-category-groups';

export type HelpCenterSearchCategoryGroup = HelpCenterCategoryGroup;

type HelpCenterHomeSearchResultsProps = {
    groups: HelpCenterSearchCategoryGroup[];
    isCategoryExpanded: (categoryId: number) => boolean;
    onToggleCategory: (categoryId: number) => void;
    onSelectPage: (slug: string) => void;
};

export function HelpCenterHomeSearchResults({
    groups,
    isCategoryExpanded,
    onToggleCategory,
    onSelectPage,
}: HelpCenterHomeSearchResultsProps) {
    return (
        <Stack spacing={2} sx={{ width: '100%' }}>
            <Typography variant='h5' color='primary'>
                {_('Resultados de búsqueda')}
            </Typography>
            <HelpCategoryGroups
                groups={groups}
                isCategoryExpanded={isCategoryExpanded}
                onToggleCategory={onToggleCategory}
                onSelectPage={onSelectPage}
            />
        </Stack>
    );
}
